/**
 * Enumeration which represents type of the absence case.s
 */
export enum AbsenceCaseTypeEnumeration {
	NEW = 'new',
	PROLONGATION = 'prolongation',
	CLOSED = 'close',
}
